import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { translationKeys } from '../core';
import { AvanoMessageCategory, AvanoToasterService } from '@avano/avano-components/avano-feedback';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  private infoHeaderKey = translationKeys.notificationService.notification.header.INFO;
  private successHeaderKey = translationKeys.notificationService.notification.header.SUCCESS;
  private warningHeaderKey = translationKeys.notificationService.notification.header.WARNING;
  private errorHeaderKey = translationKeys.notificationService.notification.header.ERROR;

  constructor(private toasterService: AvanoToasterService, private translateService: TranslateService) {}

  showInfo(infoMessageKey: string, interpolateParams?: Record<string, unknown>): void {
    this.showMessage(this.infoHeaderKey, infoMessageKey, AvanoMessageCategory.info, interpolateParams);
  }

  showSuccess(successMessageKey: string, interpolateParams?: Record<string, unknown>): void {
    this.showMessage(this.successHeaderKey, successMessageKey, AvanoMessageCategory.success, interpolateParams);
  }

  showWarning(warningMessageKey: string, interpolateParams?: Record<string, unknown>): void {
    this.showMessage(this.warningHeaderKey, warningMessageKey, AvanoMessageCategory.warning, interpolateParams);
  }

  showError(errorMessageKey: string, interpolateParams?: Record<string, unknown>): void {
    this.showMessage(this.errorHeaderKey, errorMessageKey, AvanoMessageCategory.error, interpolateParams);
  }

  private showMessage(headerKey: string, messageKey: string, category: AvanoMessageCategory, interpolateParams?: Record<string, unknown>) {
    const translatedMsgHeader = this.translateService.instant(headerKey);
    const translatedMsgText = this.translateService.instant(messageKey, interpolateParams);

    this.toasterService.pushNotification({
      category: category,
      title: translatedMsgHeader,
      description: translatedMsgText
    });
  }
}
